var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "account-title-balance-header" }, [
    _c("div", [_vm._v(_vm._s(_vm.params.displayName))]),
    _c("div", { staticClass: "unit" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AmountNumber")))]),
      _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OriginalCurrency")))]),
      _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LocalCurrency")))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }